import { FunctionComponent, useEffect, useMemo, useState } from 'react';
import { TribeMessage } from '@components/TribeMessage';
import { ITribes, ITribesChatDetailMessages, ITribesMembers } from '@interfaces/ITribes';
import chatDetail, { getList, reset } from '@stores/chatDetail';
import { Empty, Spin } from 'antd';
import useTranslate from '@hooks/useTranslate';
import componentContent from './ChatDetail.content.json';
import { useStore } from 'effector-react';
import { useParams } from 'react-router';

type ChatDetailStore = {
  chat: {
    messages?: ITribesChatDetailMessages[];
    tribeInfo?: ITribes;
    created_by?: { id: string } | null;
    members?: ITribesMembers[] | null;
  };
  preloaders: Record<string, boolean | string>;
};

const ChatDetail: FunctionComponent = () => {
  const content = useTranslate(componentContent);
  const { chatId } = useParams<{ chatId: ITribes['chatId'] }>();
  const { chat, preloaders }: ChatDetailStore = useStore(chatDetail);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    reset();
    setIsLoading(true);

    getList({ chatId }).finally(() => setIsLoading(false));

    return () => reset();
  }, [chatId]);

  const onLoadMore = () => {
    const lastId = chat?.messages?.[chat.messages.length - 1]?.id;
    if (!lastId) return;

    setIsLoading(true);
    getList({ chatId, lastMessageId: lastId }).finally(() => setIsLoading(false));
  };

  const tribeId = chat?.tribeInfo?.id;
  const ownerId = chat?.created_by?.id;

  const membersSet = useMemo(() => {
    const ids = (chat.members ?? []).map((m) => String(m.account?.id));
    return new Set(ids);
  }, [chat.members]);

  return (
    <>
      <Spin spinning={!!preloaders.getList && isLoading}>
        {chat.messages &&
          chat.messages.map((item: ITribesChatDetailMessages) => {
            const isMemberDeleted = !membersSet.has(String(item.user.id));

            return (
              <TribeMessage
                key={item.id}
                message={item}
                chatId={chatId}
                tribeId={tribeId}
                ownerId={ownerId}
                isMemberDeleted={isMemberDeleted}
              />
            );
          })}

        {(!chat.messages || !chat.messages.length) && <Empty imageStyle={{ height: '50px' }} />}
        {chat?.messages?.length ? (
          <div style={{ marginTop: 12 }}>
            <a onClick={onLoadMore}>{content.show_more}</a>
          </div>
        ) : null}
      </Spin>
    </>
  );
};
export default ChatDetail;
